import Vue from 'vue';

import { mapState, mapMutations } from 'vuex';

import { store } from '@src/store';

let PageComponent = {
  name: 'history',
  data() {
    return {
      template: '<p>default temp</p>',
      itemVisible: false,
    };
  },
  computed: {
    leftMenuVisible: function() {
      return window.innerWidth < 1280;
    },
    ...mapState('params', ['userMenu']),
  },
  methods: {
    ...mapMutations('cart', ['addItemToCart']),
    setTemplate: function(template) {
      this.template = template.data;
    },
    setData: function(data, to) {
      this.setTemplate(data);
    },
    toogleHistoryItemVisible: function(id) {
      this.$refs[id].classList.toggle('open');
    },
    addToCard: function(products) {
      console.log('products', products);
      products.forEach((item) => {
        if (item.isActual) {
          this.addItemToCart(item);
        }
      });
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeRouteEnter(to, from, next) {
    //store.state.params.userMenu
    if (true) {
      let products = document.querySelector('#history');
      if (products) {
        products.remove();
      }

      let url = '/api/templates/history';
      Vue.http.get(url, { params: to.query }).then((data) => {
        next((vm) => vm.setData(data));
      });
    } else {
      next('/403');
    }
  },
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement);
  },
};
export default PageComponent;



// WEBPACK FOOTER //
// ./src/templates/pages/history/index.js